<template>
  <div>
    <div id="content">
      <slot name="content"></slot>
    </div>
    <div id="lock-content" class="d-flex align-items-center">
      <div class="lock-message-box ml-auto mr-auto">
        <div class="rectangle-rotate ml-auto mr-auto"></div>
        <div class="lock-title">
          Ruota il device per l’esperienza completa
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScreenLocker"
};
</script>

<style scoped></style>
